
import NumberUtils from "../utils/NumberUtils";
import DateUtils from "../utils/DateUtils";

export function privateMoney(val) {
  return NumberUtils.isEmpty(val) ? '' : NumberUtils.formatData(val);
}
export function formattingDate(date) {
  return date ? DateUtils.format(date, "yyyy-MM-dd") : ''
} 


// WEBPACK FOOTER //
// ./src/libs/filters/filters.js